module.exports = __webpack_public_path__ + "img/PH.522e71fc.png";